// Exports
export default {
	"stopButton": "stopButton_wpqIj"
};
